import { Fragment } from 'react';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import CancelConfirmModal from './CancelConfirmModal';

import { useState } from 'react';

import IRunEntry from 'types/IRunEntry';

const CANCELLABLE_STATES = ['RUNNING', 'READY', 'WAITING', 'RESERVED', 'FAILED'];

export default function CancelButton({ selectedRuns }: { selectedRuns: IRunEntry[] }) {
  const cancellableRuns = selectedRuns.filter((run) => CANCELLABLE_STATES.includes(run.state));

  const [showModal, setShowModal] = useState(false);

  return (
    <Fragment>
      <Tooltip
        title={
          selectedRuns.length === 0
            ? 'Select workflows to cancel'
            : cancellableRuns.length === 0
              ? 'No selected workflows can be cancelled'
              : `Cancel selected workflows (${cancellableRuns.length})`
        }
        placement="bottom-start"
      >
        <span>
          <Button
            variant="contained"
            color="primary"
            disabled={cancellableRuns.length === 0}
            onClick={() => setShowModal(true)}
          >
            Cancel
          </Button>
        </span>
      </Tooltip>

      {showModal && <CancelConfirmModal onClose={() => setShowModal(false)} selectedRuns={cancellableRuns} />}
    </Fragment>
  );
}
